"use client"

import { NotificationListRenderProps } from "@/types/types"
import { ComponentConfig, CustomField } from "@measured/puck"
import { useMemo } from "react"
import { CategorySelect, CategorySelectProps } from "../../../components/CategorySelect"
import { useCategorySelectSync } from "./hooks/useCategorySelectSync"
import { RenderConfig } from "./RenderConfig"

let instanceCounter = 0
const instanceIdMap = new Map<string, string>()

const getOrCreateInstanceId = (componentKey: string): string => {
  const globalKey = `notification-list-${componentKey}`

  if (!instanceIdMap.has(globalKey)) {
    const newInstanceId = `notification-list-instance-${instanceCounter++}`
    instanceIdMap.set(globalKey, newInstanceId)
    return newInstanceId
  }

  return instanceIdMap.get(globalKey)!
}

const CategorySelectWrapper = (props: any) => {
  const componentKey = "notification-list-shared"
  const instanceId = useMemo(() => getOrCreateInstanceId(componentKey), [])

  const { handleChange } = useCategorySelectSync({
    instanceId,
    categoryId: props.value?.categoryId,
    onChange: props.onChange,
  })

  return <CategorySelect {...(props as CategorySelectProps)} requireWebsite={false} onChange={handleChange} />
}

export const NotificationList: ComponentConfig<NotificationListRenderProps> = {
  label: "Tamda One | Notification List",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    viewAllLink: {
      label: "View All Link",
      type: "text",
    },
    category: {
      label: "Category",
      type: "custom",
      render: (props: any) => <CategorySelectWrapper {...props} />,
    } as CustomField<{ categoryId: number; categoryName: string; slug?: string } | undefined>,
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    title: "Thông báo",
    viewAllLink: "",
    category: undefined,
    className: "",
  },
  ...RenderConfig,
}
